import { CalendarIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

import { Card } from '../../../../../../common/Card';
import { Dialog } from '../../../../../../common/Dialog';
import { formatDuration } from '../../../../../../utils/dateUtils';
import { MeetingsItem, TSessionCheckInTime } from '../../../../types/timeline';
import { isSessionEnded } from '../../../../utils/timelineUtils';

import { MeetingsDetailView } from './MeetingsDetailView';

interface MeetingsCardProps {
  item: MeetingsItem;
  checkInTime: TSessionCheckInTime | undefined;
}

export function MeetingsCard({
  item,
  checkInTime,
}: MeetingsCardProps): JSX.Element {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const sessionEnded = checkInTime ? isSessionEnded(checkInTime, false) : true;
  return (
    <>
      <div className="flex items-center w-full text-[#434343] font-[400]">
        <Card
          onClick={() => setIsDialogOpen(true)}
          className="w-full px-3 cursor-pointer select-text hover:bg-gray-50 relative"
        >
          <div className="flex flex-row items-center gap-2 w-full">
            <CalendarIcon className="h-5 w-5 text-green-600 flex-shrink-0" />
            <span className="text-text-label text-md leading-5 line-clamp-1 text-left font-regular w-full">
              {sessionEnded ? 'Attended' : 'Scheduled'} {item.meetings.length}{' '}
              {item.meetings.length === 1 ? 'Meeting' : 'Meetings'}
            </span>
            <span className="text-text-label text-md leading-5 text-left font-regular flex-shrink-0">
              {formatDuration(item.totalDurationMinutes / 60)}
            </span>
          </div>
        </Card>
      </div>

      <Dialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        title={
          <div className="flex items-center gap-2 w-full">
            <CalendarIcon className="h-5 w-5 text-green-600 flex-shrink-0" />
            <span className="text-text-label text-md leading-5 text-left font-regular w-full">
              {sessionEnded ? 'Attended' : 'Scheduled'} {item.meetings.length}{' '}
              Meetings ({formatDuration(item.totalDurationMinutes / 60)})
            </span>
          </div>
        }
      >
        <MeetingsDetailView meetings={item.meetings} />
      </Dialog>
    </>
  );
}
